module.exports = "<app-nav></app-nav>\r\n<app-alert></app-alert>\r\n<h1>Arithmetic Algebraic Geometry<br><span id=\"smallTitle\">26.08-01.09.2018 Poznań, Poland</span></h1>\r\n<div id=\"logo\">\r\n  <img src=\"/assets/graphics/banaszak.jpg\"  alt=\"Grzegorz Banaszak\">\r\n</div>\r\n\r\n<h2 id = \"subTitle\">A conference in honor of the 60th Birthday of<br/>Grzegorz Banaszak</h2>\r\n<router-outlet></router-outlet>\r\n<app-sponsors></app-sponsors>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/rzonsol/WebstormProjects/banaszak60/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main